import React from 'react'
import { css } from '@emotion/core'
import { useAtSize } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import { getSessionId } from '@fs/zion-session'
import Row from '../../../../../../wcf/AppWcf/components/FamilyLines/Row'
import Relative from '../../../../../../wcf/AppWcf/components/FamilyLines/Relative'
import findAncestryLines from '../../../../../../wcf/global/findAncestryLines'
import findNewLineType, { isActiveAtn } from '../../../../../../wcf/global/findNewLineType'
import TreeType from '../../../../../propTypes/treeProps'
import { PersonType } from '../../../../../propTypes/personDataProps'
import { useAncestorImageData } from '../../../../../../wcf/global/hooks'

export default function PersonRelationship({ personData, tree, initialPerson, onPersonClick }) {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const sessionId = getSessionId()
  const userImage = useAncestorImageData({ personId: tree[0]?.personId, sessionId })

  const lines = findAncestryLines(initialPerson?.personId || personData.personId, tree)

  const parentArray = [lines[0]] // Add the user first

  const missingSpouse = (spouseAtn) => {
    return { atn: spouseAtn, gender: 'unknown', name: t('wif.familylines.unknown', 'Unknown') }
  }
  for (let i = 1; i < lines.length; i++) {
    if (lines[i].atn % 2 === 0) {
      parentArray.push(lines[i])
      const parent = tree.findIndex((person) => person.atn === lines[i].atn)
      const spouseAtn = tree[parent].atn + 1
      const spouse = tree.some((person) => person.atn === spouseAtn)
      parentArray.push(spouse ? tree[parent + 1] : missingSpouse(spouseAtn))
    }
    if (lines[i].atn % 2 !== 0) {
      const parent = tree.findIndex((person) => person.atn === lines[i].atn)
      const spouseAtn = tree[parent].atn - 1
      const spouse = tree.some((person) => person.atn === spouseAtn)
      parentArray.push(spouse ? tree[parent - 1] : missingSpouse(spouseAtn))
      parentArray.push(lines[i])
    }
  }

  const rowArray = []
  if (parentArray.length > 0) {
    for (let i = 1; i < parentArray.length; i += 2) {
      rowArray.unshift({
        parentOne: parentArray[i],
        parentTwo: parentArray[i + 1],
      })
    }
  }

  const container = css`
    ${atSize({ default: 'display: flex', xxl: 'hide' })};
    ${atSize({ default: 'flex-direction: column', xxl: 'hide' })};
    ${atSize({ default: 'align-items: center', xxl: 'hide' })};
    ${atSize({ default: 'justify-content: center', xxl: 'hide' })};
  `

  return (
    <div css={container}>
      {rowArray.map((couple) => {
        const actives = isActiveAtn({
          rightAtn: couple.parentOne.atn,
          leftAtn: couple.parentTwo.atn,
          treeData: lines,
        })

        return (
          <Row
            key={couple.parentOne.atn}
            parentOne={couple.parentOne}
            parentTwo={couple.parentTwo}
            userId={tree[0].personId}
            lineType={findNewLineType(couple.parentOne, couple.parentTwo, lines, 'generations')}
            view="generations"
            parentOneActive={actives.right}
            parentTwoActive={actives.left}
            onParentOneClick={actives.right ? onPersonClick : () => {}}
            onParentTwoClick={actives.left ? onPersonClick : () => {}}
          />
        )
      })}
      <div css={{ display: 'flex', justifyContent: 'center' }}>
        <Relative
          isSelf
          currentUserId={tree[0].personId}
          userImage={userImage}
          name={tree[0].name}
          surname={tree[0].surname}
          gender={tree[0].gender}
          personId={tree[0].personId}
          view="generations"
        />
      </div>
    </div>
  )
}

PersonRelationship.propTypes = {
  personData: PersonType,
  tree: TreeType,
  initialPerson: PersonType,
  onPersonClick: func,
}
